/**
 *    @author:
 *    @since:
 *
 */

import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { AboutTheChildMainComponent} from './about_the_child_main.component';
import { AboutChild, ParentInfo } from '../_common/data/input-data';
import { ViewportScroller } from '@angular/common';

const PREFIX = "about_the_child_main.error.";

export class AboutTheChildMainValidation extends IValidator {

       constructor(private component: AboutTheChildMainComponent,
                   private viewportScroller: ViewportScroller,
                   private inputChild:AboutChild,
                   private compoID:number ) {
                         super();

                   this.aboutChild.backup(inputChild);
       }        

       private aboutChild:AboutChild = new AboutChild();
       
       private success: boolean;

       public validate(): boolean {

            this.success = true;
            
            if ( this.component.aboutChild.name.chk_singleName != 'Y' ) {

            if ( Util.isEmpty(this.component.aboutChild.name.first)) {  
                  this.focus("childName","input_childFirstName").error_childFirstName = PREFIX + 'childFirstName_empty';
             }    else if (!Util.isValidName(this.component.aboutChild.name.first)) {
                  this.focus("childName","input_childFirstName").error_childFirstName = PREFIX + 'childFirstName_special';
             }

            if ( this.component.aboutChild.name.chk_middleNA == false  ) 
            if ( Util.isEmpty(this.component.aboutChild.name.middle) ) {  
                  this.focus("childName","input_childMiddleName").error_childMiddleName = PREFIX + 'childMiddleName_empty';
             } else if (!Util.isValidName(this.component.aboutChild.name.middle)) {
                  this.focus("childName","input_childMiddleName").error_childMiddleName = PREFIX + 'childMiddleName_special';
             }
             if ( this.component.aboutChild.isParentAgreeOnLastName != 'N' )
             if ( Util.isEmpty(this.component.aboutChild.name.last) ) {  
                  this.focus("childName","input_childLastName").error_childLastName = PREFIX + 'childLastName_empty';
             } else if (!Util.isValidName(this.component.aboutChild.name.last)) {
                  this.focus("childName","input_childLastName").error_childLastName = PREFIX + 'childLastName_special';
             }
            }

             if ( Util.isEmpty(this.component.aboutChild.isParentAgreeOnLastName)
                  && this.component.parentCount > 1 && !this.component.isCustodyOtherThanParent &&
                  this.component.aboutChild.name.chk_singleName !='Y') {  
                  this.focus("isParentAgree","radio_isParentAgreeRadio_0").error_parentsAgree = PREFIX + 'parentsAgree_empty';
             }

             if ( this.component.aboutChild.isParentAgreeOnLastName === 'N' 
                  &&  this.component.aboutChild.name.chk_singleName !='Y' ) {

                  if ( Util.isEmpty(this.component.parents[0].name.last) )   
                        this.focus("parentAgree","input_motherLastName").error_parentCurLastName = PREFIX + 'parentCurLastName_empty_surro$';

                  if ( !Util.isValidName(this.component.parents[0].name.last) )
                        this.focus("parentAgree","input_motherLastName").error_parentCurLastName = PREFIX + 'parentCurLastName_special_surro$';
                  
                  for ( let i = 1; i < this.component.parentCount; i++ ) {
                        let  parentInfo:ParentInfo = this.component.parents[i];
                        this.lastNameValidation(parentInfo,i);
                  }

                  if ( this.component.aboutChild.name.last.length > 50 ) 
                       this.jump("parentNameInput");
             }

             if ( Util.isEmpty(this.component.aboutChild.name.single)
              && this.component.aboutChild.name.chk_singleName==='Y') { 
              this.focus("singleName","input_childSingleName").error_childSingleName = PREFIX + 'childSingleName_empty';
             }else if ( !Util.isValidName(this.component.aboutChild.name.single)
                && this.component.aboutChild.name.chk_singleName==='Y') { 
                this.focus("singleName","input_childSingleName").error_childSingleName = PREFIX + 'childSingleName_special';
             }

             if ( Util.isEmpty(this.component.aboutChild.isParentAgreeOnSingleName)
              && this.component.aboutChild.name.chk_singleName==='Y' && this.component.parentCount > 1 && !this.component.isCustodyOtherThanParent || 
              this.component.aboutChild.isParentAgreeOnSingleName==='N' && this.component.aboutChild.name.chk_singleName==='Y' 
              && this.component.parentCount > 1 && !this.component.isCustodyOtherThanParent) { 
              this.focus("singleName","radio_parentAgreeSingleNameRadio_0").error_parentsAgreeSN = PREFIX + 'childSingleName_parentsagree';
             }

             if ( Util.isEmpty(this.component.aboutChild.gender) ) { 
                  this.focus("childGender","radio_childGenderRadio_0").error_gender = PREFIX + 'sex_of_child_empty';
             }

             //==================== weight =====================================
             if ( !Util.isEmptyNumber(this.component.aboutChild.grams) ) { 
                  if ( this.component.aboutChild.grams < 500 || this.component.aboutChild.grams > 9072 )  
                       this.focus("childWeight","input_childWeightGrams").error_childs_weight = PREFIX + 'childs_weight_grams_limit';
             }
             else 
             if ( !Util.isEmptyNumber(this.component.aboutChild.pounds) ) {
                  if ( (this.component.aboutChild.pounds < 1 || this.component.aboutChild.pounds > 20))  
                        this.focus("childWeight","input_childWeightPounds").error_childs_weight = PREFIX + 'childs_weight_pounds_limit';
                  else      
                  if ( Util.isEmptyNumber(this.component.aboutChild.ounces) )  // zero?
                       this.focus("childWeight","input_childWeightOunces").error_childs_weight = PREFIX + 'childs_weight_onces_limit';
                  else
                  if ( this.component.aboutChild.ounces > 15 ||  this.component.aboutChild.ounces < 0)  
                       this.focus("childWeight","input_childWeightOunces").error_childs_weight = PREFIX + 'childs_weight_onces_limit';
             }
             else {
                  if ( !Util.isEmptyNumber(this.component.aboutChild.ounces) )
                        this.focus("childWeight","input_childWeightPounds").error_childs_weight = PREFIX + 'childs_weight_ounces';
                  else  
                  if ( !this.component.isCustodyOtherThanParent ) {
                        if ( Util.isEmptyNumber(this.component.aboutChild.grams) && this.component.grams )
                              this.focus("childWeight","input_childWeightGrams").error_childs_weight = PREFIX + 'childs_weight_empty';
                        else 
                        if( Util.isEmptyNumber(this.component.aboutChild.pounds) && Util.isEmptyNumber(this.component.aboutChild.ounces)
                              && this.component.poundsOunces )
                              this.focus("childWeight","input_childWeightPounds").error_childs_weight = PREFIX + 'childs_weight_empty';
                  }
             }

             if( Util.isEmpty(this.component.data.aboutChild.birthOrder) && this.component.data.eligibility.birthType != '1' ) {
                  this.focus("birthOrder","select_birthOrderSelect").error_childs_birth_order = PREFIX + 'birth_order_empty';
             } else if(parseInt(this.component.data.aboutChild.birthOrder) > parseInt(this.component.data.eligibility.birthType)){
                  this.focus("birthOrder","select_birthOrderSelect").error_childs_birth_order = PREFIX + 'birth_order_not_match';
             } else if(this.component.data.subject.containsBirthOrder(this.component.data.aboutChild.birthOrder)){
                  this.focus("birthOrder","select_birthOrderSelect").error_childs_birth_order = PREFIX + 'birth_order_same';
             }

             if ( Util.isEmpty(this.component.aboutChild.cityTown) ) {  
                  this.focus("childCityTown","select_childCityTownSelect").error_childs_city_town = PREFIX + 'city_town_child_born_empty';
             }

             if ( Util.isEmpty(this.component.aboutChild.otherCity)
                   && this.component.aboutChild.cityTown === this.component.NotFound) {  
                  this.focus("childCityTown","input_childCityTownOther").error_otherCity = PREFIX + 'other_city_town_empty';
              } else if (Util.hasSpecialCharacter(this.component.aboutChild.otherCity)
                   && this.component.aboutChild.cityTown === this.component.NotFound) {
                  this.focus("childCityTown","input_childCityTownOther").error_otherCity = PREFIX + 'other_city_town_special';
             }

             if ( Util.isEmpty(this.component.aboutChild.birthPlaceType) ) { 
                  this.focus("childBirthPlace","radio_childBirthPlaceRadio_0").error_childs_place = PREFIX + 'place_child_born_empty';
             }

             if ( Util.isEmpty(this.component.aboutChild.birthPlaceCode)
                   && this.component.aboutChild.birthPlaceType=='HO') {    
                  this.focus("childBirthPlace","select_hospitalSelect").error_hospital = PREFIX + 'whichhospital_empty';
             }

             if ( Util.isEmpty(this.component.aboutChild.birthPlaceCode)
                   && this.component.aboutChild.birthPlaceType=='BC') { 
                  this.focus("childBirthPlace","select_birthingCentreSelect").error_birthingCentre = PREFIX + 'whichBirthingCentre_empty';
             }

             if ( Util.isEmpty(this.component.aboutChild.birthStreetNumber)) {
                   if( this.component.aboutChild.birthPlaceType=='HM')  
                       this.focus("childBirthPlace","input_homeStreetNumber").error_streetNumber = PREFIX + 'streetNumber_empty';
             }
             else 
             if ( Util.hasSpecialCharacter(this.component.aboutChild.birthStreetNumber) ) {
                  if ( this.component.aboutChild.birthPlaceType=='HM')  
                       this.focus("childBirthPlace","input_homeStreetNumber").error_streetNumber = PREFIX + 'homeStreetName_special';
                  else
                  if ( this.component.aboutChild.birthPlaceType=='OT')  
                       this.focus("childBirthPlace","input_otherStreetNumber").error_streetNumber = PREFIX + 'homeStreetName_special';
             }
             
             if ( Util.isEmpty(this.component.aboutChild.birthStreetName) ) {
                  if ( this.component.aboutChild.birthPlaceType=='HM')  
                       this.focus("childBirthPlace","input_homeStreetName").error_streetNameRuralRoute = PREFIX + 'streetName_ruralRoute_empty';
                  else
                  if ( this.component.aboutChild.birthPlaceType=='OT')  
                       this.focus("childBirthPlace","input_otherStreetName").error_streetNameRuralRouteIntersection = PREFIX + 'streetName_ruralRoute_Intersection_title_empty';
             }
             else 
             if ( Util.hasSpecialCharacter(this.component.aboutChild.birthStreetName) ) {
                  if ( this.component.aboutChild.birthPlaceType=='HM')  
                       this.focus("childBirthPlace","input_homeStreetName").error_streetNameRuralRoute = PREFIX + 'homeStreetName_special';
                  else
                  if ( this.component.aboutChild.birthPlaceType=='OT')  
                       this.focus("childBirthPlace","input_otherStreetName").error_streetNameRuralRouteIntersection = PREFIX + 'homeStreetName_special';
             }
 
             if(this.component.aboutChild.birthPlaceType==='HO'
                  && this.component.deliveredByOther) {
                  if ( !this.component.data.isNextChild )      
                        this.focus("childBirthPlace","radio_childBirthPlaceRadio_0").error_deliveredByOtherHospital = PREFIX + 'deliveredByOther_hospital';
             }
             
             if ( Util.isEmpty(this.component.aboutChild.otherBirthPlace) 
                  && this.component.aboutChild.birthPlaceType==='HO'
                  && this.component.aboutChild.birthPlaceCode===this.component.NotFound) {  
                  this.focus("childBirthPlace","input_hospitalOther").error_otherHospital = PREFIX + 'other_hospital_empty';
             }

             if (Util.hasSpecialCharacter(this.component.aboutChild.otherBirthPlace)
                  && this.component.aboutChild.birthPlaceType==='HO'
                  && this.component.aboutChild.birthPlaceCode===this.component.NotFound) {
                  this.focus("childBirthPlace","input_hospitalOther").error_otherHospital = PREFIX + 'other_hospital_special';
             }

             if ( Util.isEmpty(this.component.aboutChild.otherBirthPlace) 
                  && this.component.aboutChild.birthPlaceType==='BC'
                  && this.component.aboutChild.birthPlaceCode===this.component.NotFound) {  
                  this.focus("childBirthPlace","input_birthingCentreOther").error_otherBirthingCentre = PREFIX + 'other_birthing_centre_empty';
              }

             if (Util.hasSpecialCharacter(this.component.aboutChild.otherBirthPlace)
                  && this.component.aboutChild.birthPlaceType==='BC'
                  && this.component.aboutChild.birthPlaceCode===this.component.NotFound) {
                  this.focus("childBirthPlace","input_birthingCentreOther").error_otherBirthingCentre = PREFIX + 'other_birthing_centre_special';
              }

              //---------- attendant -------------------------------
              if ( !this.component.isCustodyOtherThanParent ) {

                  if ( Util.isEmpty(this.component.aboutChild.attendentType))   
                       this.focus("childAttendent","radio_childAttendentRadio_0").error_attendentType = PREFIX + 'who_delivered_empty';
                  else {
                       if ( Util.isEmpty(this.component.aboutChild.attendentFirstName) 
                              && this.component.aboutChild.attendentType==='P'
                              && this.component.aboutChild.isDoctorSingleName!='Y') {  
                              this.focus("childAttendent","input_attendentFirstName").error_attendantFirstName = PREFIX + 'physician_first_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentFirstName) 
                              && this.component.aboutChild.attendentType==='P'
                              && this.component.aboutChild.isDoctorSingleName!='Y') {  
                              this.focus("childAttendent","input_attendentFirstName").error_attendantFirstName = PREFIX + 'physician_first_name_special';
                       }
                       else {
                              let   firstName = this.component.aboutChild.attendentFirstName.trim().toLowerCase();
                              if ( (firstName.includes("dr.") ||
                                    firstName.includes("doctor") ||
                                    firstName.includes("dr ") ||
                                    firstName.includes("docteur") ||  
                                    firstName === "dr" )
                                    && this.component.aboutChild.attendentType==='P'
                                    && this.component.aboutChild.isDoctorSingleName!='Y') {  
                                    this.focus("childAttendent","input_attendentFirstName").error_attendantFirstName = PREFIX + 'physician_first_name_dr';
                              }
                       }     
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentLastName) 
                           && this.component.aboutChild.attendentType==='P'
                           && this.component.aboutChild.isDoctorSingleName!='Y') {  
                           this.focus("childAttendent","input_attendentLastName").error_attendantLastName = PREFIX + 'physician_last_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentLastName) 
                           && this.component.aboutChild.attendentType==='P'
                           && this.component.aboutChild.isDoctorSingleName!='Y') {  
                           this.focus("childAttendent","input_attendentLastName").error_attendantLastName = PREFIX + 'physician_last_name_special';
                       }
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentSingleName) 
                          && this.component.aboutChild.attendentType==='P' 
                          && this.component.aboutChild.isDoctorSingleName==='Y') {  
                          this.focus("childAttendent","input_attendentSingleName").error_attendantSingleName = PREFIX + 'physician_single_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentSingleName) 
                          && this.component.aboutChild.attendentType==='P' 
                          && this.component.aboutChild.isDoctorSingleName==='Y') {  
                          this.focus("childAttendent","input_attendentSingleName").error_attendantSingleName = PREFIX + 'physician_single_name_special';
                       }
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentFirstName) 
                          && this.component.aboutChild.attendentType==='M'
                          && this.component.aboutChild.isMidwifeSingleName!='Y') {  
                          this.focus("childAttendent","input_attendentFirstName").error_attendantFirstName = PREFIX + 'midwife_first_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentFirstName) 
                          && this.component.aboutChild.attendentType==='M'
                          && this.component.aboutChild.isMidwifeSingleName!='Y') {  
                          this.focus("childAttendent","input_attendentFirstName").error_attendantFirstName = PREFIX + 'midwife_first_name_special';
                       }
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentLastName) 
                          && this.component.aboutChild.attendentType==='M'
                          && this.component.aboutChild.isMidwifeSingleName!='Y') {  
                          this.focus("childAttendent","input_attendentLastName").error_attendantLastName = PREFIX + 'midwife_last_name_empty';
                        }else if ( !Util.isValidName(this.component.aboutChild.attendentLastName) 
                          && this.component.aboutChild.attendentType==='M'
                          && this.component.aboutChild.isMidwifeSingleName!='Y') {  
                          this.focus("childAttendent","input_attendentLastName").error_attendantLastName = PREFIX + 'midwife_last_name_special';
                       }
        
                       if ( Util.isEmpty(this.component.aboutChild.attendentSingleName) 
                          && this.component.aboutChild.attendentType==='M'
                          && this.component.aboutChild.isMidwifeSingleName==='Y') {  
                          this.focus("childAttendent","input_attendentSingleName").error_attendantSingleName = PREFIX + 'midwife_single_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentSingleName) 
                          && this.component.aboutChild.attendentType==='M'
                          && this.component.aboutChild.isMidwifeSingleName==='Y') {  
                          this.focus("childAttendent","input_attendentSingleName").error_attendantSingleName = PREFIX + 'midwife_single_name_special';
                       }
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentTitle) 
                          && this.component.aboutChild.attendentType==='O') {  
                          this.focus("childAttendent","input_attendentTitle").error_attendentTitle = PREFIX + 'other_title_empty';
                       }else if ( Util.hasSpecialCharacter(this.component.aboutChild.attendentTitle) 
                          && this.component.aboutChild.attendentType==='O') {  
                          this.focus("childAttendent","input_attendentTitle").error_attendentTitle = PREFIX + 'other_title_special';
                       }
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentFirstName) 
                          && this.component.aboutChild.attendentType==='O'
                          && this.component.aboutChild.isSomeoneElseSingleName!='Y') {  
                          this.focus("childAttendent","input_attendentFirstName").error_attendantFirstName = PREFIX + 'other_first_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentFirstName) 
                          && this.component.aboutChild.attendentType==='O'
                          && this.component.aboutChild.isSomeoneElseSingleName!='Y') {  
                          this.focus("childAttendent","input_attendentFirstName").error_attendantFirstName = PREFIX + 'other_first_name_special';
                       }
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentLastName) 
                          && this.component.aboutChild.attendentType==='O'
                          && this.component.aboutChild.isSomeoneElseSingleName!='Y') {  
                          this.focus("child_attendent","input_attendentLastName").error_attendantLastName = PREFIX + 'other_last_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentLastName) 
                          && this.component.aboutChild.attendentType==='O'
                          && this.component.aboutChild.isSomeoneElseSingleName!='Y') {  
                          this.focus("childAttendent","input_attendentLastName").error_attendantLastName = PREFIX + 'other_last_name_special';
                       }
       
                       if ( Util.isEmpty(this.component.aboutChild.attendentSingleName) 
                          && this.component.aboutChild.attendentType==='O'
                          && this.component.aboutChild.isSomeoneElseSingleName==='Y') {  
                          this.focus("childAttendent","input_attendentSingleName").error_attendantSingleName = PREFIX + 'other_single_name_empty';
                       }else if ( !Util.isValidName(this.component.aboutChild.attendentSingleName) 
                         && this.component.aboutChild.attendentType==='O'
                         && this.component.aboutChild.isSomeoneElseSingleName==='Y') {  
                         this.focus("childAttendent","input_attendentSingleName").error_attendantSingleName = PREFIX + 'other_single_name_special';
                       }

                       if ( !this.component.data.isNextChild )      {
                             if(this.component.aboutChild.attendentType==='P' && this.component.deliveredByOther){
                                this.focus("childAttendent","radio_childAttendentRadio_0").error_deliveredByOther = PREFIX + 'deliveredByOther_doctor';
                             }
                  
                             if(this.component.aboutChild.attendentType==='M' && this.component.deliveredByOther){
                                this.focus("childAttendent","radio_childAttendentRadio_0").error_deliveredByOther = PREFIX + 'deliveredByOther_midwife';
                             }
                  
                             if(this.component.aboutChild.attendentType==='O' && !this.component.deliveredByOther){
                                this.focus("childAttendent","radio_childAttendentRadio_0").error_deliveredByOther = PREFIX + 'deliveredByOther_other';
                             }
                       }
                       else {

                              if(this.component.aboutChild.birthPlaceType==='HO' &&
                                 this.component.aboutChild.attendentType==='O'  ) {
                                 this.focus("childAttendent","radio_childAttendentRadio_2").error_deliveredByOther = PREFIX + 'someoneElseForHospital';
                              }
                       }
                  }
              }

             
             return this.success;

       }
       
       private lastNameValidation(parentInfo:ParentInfo,i:number) {

             if ( Util.isEmpty(parentInfo.name.last) )  
                  this.focus("parentAgree","input_parentLastName" + i).errorLastName[i] = PREFIX + 'nextParentCurLastName_empty_surro$';

             if ( !Util.isValidName(parentInfo.name.last)  )  
                  this.focus("parentAgree","input_parentLastName" + i).errorLastName[i] = PREFIX + 'nextParentCurLastName_special_surro$';

       }

       private jump(tagId:string) : AboutTheChildMainComponent {
            if ( this.success )
                 this.viewportScroller.scrollToAnchor(tagId);
            this.success = false;
            return this.component;
       }

       private focus(tagId:string,ctrlId:string) : AboutTheChildMainComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

       public IdOfChanged():number {
              
              if ( this.aboutChild.name.first !=  this.inputChild.name.first ||
                   this.aboutChild.name.middle !=  this.inputChild.name.middle ||
                   this.aboutChild.name.last !=  this.inputChild.name.last ||
                   this.aboutChild.name.single !=  this.inputChild.name.single ||
                   this.aboutChild.birthOrder !=  this.inputChild.birthOrder ||
                   this.aboutChild.gender !=  this.inputChild.gender ||
                   this.aboutChild.grams !=  this.inputChild.grams ||
                   this.aboutChild.pounds !=  this.inputChild.pounds ||
                   this.aboutChild.ounces !=  this.inputChild.ounces ||
                   this.aboutChild.cityTown !=  this.inputChild.cityTown ||
                   this.aboutChild.otherCity !=  this.inputChild.otherCity ||
                   this.aboutChild.birthPlaceType !=  this.inputChild.birthPlaceType ||
                   this.aboutChild.birthPlaceCode !=  this.inputChild.birthPlaceCode ||
                   this.aboutChild.otherBirthPlace !=  this.inputChild.otherBirthPlace ||
                   this.aboutChild.birthStreetName !=  this.inputChild.birthStreetName ||
                   this.aboutChild.birthStreetNumber !=  this.inputChild.birthStreetNumber ||
                   this.aboutChild.attendentType !=  this.inputChild.attendentType ||
                   this.aboutChild.attendentFirstName !=  this.inputChild.attendentFirstName ||
                   this.aboutChild.attendentLastName !=  this.inputChild.attendentLastName ||
                   this.aboutChild.attendentTitle !=  this.inputChild.attendentTitle ||
                   this.aboutChild.isDoctorSingleName !=  this.inputChild.isDoctorSingleName ||
                   this.aboutChild.isMidwifeSingleName !=  this.inputChild.isMidwifeSingleName ||
                   this.aboutChild.isSomeoneElseSingleName !=  this.inputChild.isSomeoneElseSingleName ) return this.compoID;
              return 0;
       }
}

